import { render, staticRenderFns } from "./CuentaAtras.vue?vue&type=template&id=67e3ab10&scoped=true"
import script from "./CuentaAtras.vue?vue&type=script&lang=js"
export * from "./CuentaAtras.vue?vue&type=script&lang=js"
import style0 from "./CuentaAtras.vue?vue&type=style&index=0&id=67e3ab10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3ab10",
  null
  
)

export default component.exports